import { useDispatch } from 'react-redux';
import { useAppSelector } from '@hooks/reduxHooks';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';
import { useQueryParams } from 'use-query-params';

import { offerConstants } from 'modules/offer';

import { setOfferTerms, setRejected, setView } from '../store';

export function useOfferAction() {
  const qc = useQueryClient();
  const dispatch = useDispatch();
  const [query] = useQueryParams(offerConstants.offerQueryParams);
  const view = useAppSelector(({ realtorOfferReducer: { view } }) => view);

  return useMutation(
    async (payload: object) => {
      const { data } = await $api.put('/v1/offer/realtor-action', payload);

      return data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async data => {
        await qc.invalidateQueries([offerConstants.queryKeys.OFFER, query]);

        showMessage(data?.message, data?.accept);

        dispatch(
          setView({
            ...view,
            visible: false
          })
        );

        dispatch(
          setOfferTerms({
            visible: false
          })
        );

        dispatch(
          setRejected({
            visible: false
          })
        );
      }
    }
  );
}
